let isEnabled = false;
let lastPlayTime = 0;
let currentVolume = 1.0;
let currentSoundKey = 'default';

const COOLDOWN_MS = 3000; // 限制 3 秒內只響一次

const soundMap = {
  default: require('@/assets/sound/通知音效01.wav'),
  // 未來可加入其他 key
  // "alert": require('@/assets/alert.wav'),
  // "soft": require('@/assets/soft-tone.mp3')
};


export const NotificationSoundManager = {
  defaultSettings: {
    enabled: false,
    volume: 1,
    soundKey: "default"
  },

  enable() {
    isEnabled = true;
  },

  disable() {
    isEnabled = false;
  },

  toggle(state) {
    isEnabled = state;
  },

  setSoundKey(key) {
    if (soundMap[key]) {
      currentSoundKey = key;
    } else {
      console.warn(`[SoundManager] 未知的 soundKey: ${key}`);
    }
  },

  initFromApi(config = {}) {
    this.toggle(config.enabled);
    this.setVolume(config.volume ?? 1.0);
    this.setSoundKey(config.soundKey ?? 'default');
  },

  setVolume(value) {
    currentVolume = Math.min(1, Math.max(0, value));
  },

  canPlay({type = '', widgetOpen = false}) {
    if (!isEnabled) return false;
    // if (widgetOpen) return false;
    return true;
  },

  playIfAllowed(context = {}) {
    const now = Date.now();
    if (now - lastPlayTime < COOLDOWN_MS) return;
    if (this.canPlay(context)) {
      const audioSrc = soundMap[currentSoundKey];
      if (!audioSrc) return;

      const audio = new Audio(audioSrc);
      audio.volume = currentVolume;
      audio.play().catch(err => {
        console.warn('[SoundManager] 播放失敗:', err);
      });
      lastPlayTime = now;
    }
  },
};
